// Minimal EN/TA translations. Keys are stable identifiers used via t().
export const translations = {
  en: {
    // nav
    "nav.home": "Home",
    "nav.services": "Services",
    "nav.gallery": "Gallery",
    "nav.about": "About",
    "nav.contact": "Contact",
    "nav.callNow": "Call Now",
    // hero
    "hero.overline": "/// Chennai · Est. Industrial Scrap Buyers",
    "hero.titleA": "We Buy",
    "hero.titleB": "Heavy Metal.",
    "hero.titleC": "Pay Fair Cash.",
    "hero.subtitle": "Bulk pickups, transparent weighing, on-the-spot payment. Industrial scrap, old machinery, electrical scrap and more.",
    "hero.quote": "Get a Quote",
    // stats
    "stats.years": "Years Operating",
    "stats.plants": "Plants Cleared",
    "stats.pickup": "Pickup Window",
    "stats.pricing": "Transparent Pricing",
    // services section
    "services.overline": "/// What We Procure",
    "services.title1": "Materials we",
    "services.title2": "specialise in.",
    "services.intro": "From small batches to full plant clearances — we handle ferrous, non-ferrous, electrical and machinery scrap across Tamil Nadu.",
    "services.industrial.title": "Industrial Scrap",
    "services.industrial.desc": "Iron, steel, stainless steel, copper, aluminium, brass — sourced from factories, plants and warehouses.",
    "services.machinery.title": "Old Machinery",
    "services.machinery.desc": "Decommissioned CNC machines, lathes, motors, gearboxes, presses — full plant clearance available.",
    "services.electrical.title": "Electrical Scrap",
    "services.electrical.desc": "Copper wires, transformers, panels, cables, busbars and electronic scrap from industrial sites.",
    "services.learnMore": "Learn more",
    // why us
    "why.overline": "/// Why Diamondd",
    "why.titleA": "Trusted by",
    "why.titleB": "factories",
    "why.titleC": "across Tamil Nadu.",
    "why.intro": "We move fast, weigh fair, and pay on the spot. No hidden deductions. No vague quotes. Decommissioning a unit, clearing a warehouse, or selling regular scrap — we handle it end-to-end.",
    "why.b1": "Transparent Weighing",
    "why.b1d": "Calibrated scales, on-site verification.",
    "why.b2": "Free Pickup",
    "why.b2d": "Logistics, loading, and labour included.",
    "why.b3": "Instant Payment",
    "why.b3d": "Cash, RTGS or NEFT before we leave.",
    "why.b4": "Responsible Recycling",
    "why.b4d": "Every kilo routed to certified processors.",
    // gallery section
    "home.gallery.overline": "/// Recent Lots",
    "home.gallery.title": "From the yard.",
    "home.gallery.viewAll": "View all",
    // CTA
    "cta.overline": "/// Ready to sell?",
    "cta.titleA": "Get a quote in",
    "cta.titleB": "under 24 hours.",
    "cta.request": "Request Quote",
    // contact
    "contact.overline": "/// Contact",
    "contact.titleA": "Let's",
    "contact.titleB": "talk scrap.",
    "contact.intro": "Tell us what you have. We'll respond with a quote and pickup window within 24 hours.",
    "contact.form.title": "Get a quote",
    "contact.form.formOverline": "/// Quote Request",
    "contact.form.name": "Name *",
    "contact.form.phone": "Phone *",
    "contact.form.email": "Email",
    "contact.form.material": "Material type",
    "contact.form.materialPh": "e.g. Copper wire, CNC machine",
    "contact.form.message": "Details *",
    "contact.form.messagePh": "Approx quantity, location, photos available, etc.",
    "contact.form.submit": "Send Inquiry",
    "contact.form.sending": "Sending…",
    "contact.form.success": "Thanks — we'll be in touch within 24 hours.",
    "contact.form.whatsapp": "Send via WhatsApp",
    "contact.info.phone": "Phone",
    "contact.info.email": "Email",
    "contact.info.address": "Address",
    "contact.bulk.overline": "/// Bulk pickups",
    "contact.bulk.text": "Free logistics for orders above 500 kg.",
    // about
    "about.overline": "/// About Diamondd Traders",
    "about.titleA": "Built on weight,",
    "about.titleB": "trust & metal.",
    "about.mission": "/// Mission",
    "about.missionText": "Convert industrial waste into responsible value — one weighbridge at a time.",
    "about.hq": "/// Headquarters",
    "about.hours": "/// Hours",
    "about.hoursText": "Mon – Sat · 9:00 AM – 7:00 PM\nSun · By appointment",
    "about.point1": "Licensed scrap dealer",
    "about.point2": "Bulk pickup capacity",
    "about.point3": "On-site weighing",
    "about.point4": "Trained loading crew",
    "about.point5": "Documented disposal",
    "about.point6": "Pan-Tamil Nadu reach",
    // services page
    "servicesPage.overline": "/// Services",
    "servicesPage.titleA": "What we",
    "servicesPage.titleB": "buy.",
    "servicesPage.intro": "We accept a wide range of ferrous, non-ferrous, electrical and machinery scrap. Bulk and one-time clearances are both welcome.",
    "servicesPage.getQuote": "Get Quote",
    // gallery page
    "galleryPage.overline": "/// Gallery",
    "galleryPage.titleA": "From our",
    "galleryPage.titleB": "yard.",
    "galleryPage.intro": "Recent procurements — machinery clearances, scrap lots, electrical takedowns.",
    "galleryPage.empty": "Photos from recent projects will appear here.",
    "galleryPage.comingSoon": "/// Coming soon",
    // footer
    "footer.tagline": "Chennai's trusted scrap & machinery procurement partner.",
    "footer.operating": "/// Operating Across Tamil Nadu",
    "footer.sitemap": "/// Sitemap",
    "footer.reach": "/// Reach Us",
    "footer.admin": "Admin",
    "footer.copyright": "All Rights Reserved",
    // whatsapp
    "wa.float": "Chat on WhatsApp",
    "wa.quoteMsg": "Hi Diamondd Traders, I'd like to request a quote.",
    "common.directions": "Get Directions",
  },
  ta: {
    "nav.home": "முகப்பு",
    "nav.services": "சேவைகள்",
    "nav.gallery": "கேலரி",
    "nav.about": "எங்களைப் பற்றி",
    "nav.contact": "தொடர்பு",
    "nav.callNow": "இப்போது அழைக்கவும்",

    "hero.overline": "/// சென்னை · தொழில்துறை ஸ்க்ராப் வாங்குபவர்கள்",
    "hero.titleA": "நாங்கள் வாங்குகிறோம்",
    "hero.titleB": "கனரக உலோகம்.",
    "hero.titleC": "நியாயமான விலை.",
    "hero.subtitle": "மொத்த சேகரிப்பு, வெளிப்படையான எடைபோடல், இடத்திலேயே பணம். தொழில்துறை ஸ்க்ராப், பழைய இயந்திரங்கள், மின் ஸ்க்ராப் மற்றும் பல.",
    "hero.quote": "விலை பெறுங்கள்",

    "stats.years": "ஆண்டுகளாக சேவை",
    "stats.plants": "தொழிற்சாலைகள் முடித்தது",
    "stats.pickup": "சேகரிப்பு நேரம்",
    "stats.pricing": "வெளிப்படையான விலை",

    "services.overline": "/// நாம் வாங்குபவை",
    "services.title1": "எங்கள் சிறப்பு",
    "services.title2": "பொருட்கள்.",
    "services.intro": "சிறிய தொகுதிகள் முதல் முழு தொழிற்சாலை அழிப்பு வரை — இரும்பு, அலுமினியம், செம்பு, பித்தளை, இயந்திரம் மற்றும் மின் ஸ்க்ராப் அனைத்தையும் தமிழ்நாடு முழுவதும் கையாள்கிறோம்.",
    "services.industrial.title": "தொழில்துறை ஸ்க்ராப்",
    "services.industrial.desc": "இரும்பு, எஃகு, ஸ்டெயின்லெஸ் ஸ்டீல், செம்பு, அலுமினியம், பித்தளை — தொழிற்சாலைகள், ஆலைகள் மற்றும் கிடங்குகளில் இருந்து.",
    "services.machinery.title": "பழைய இயந்திரம்",
    "services.machinery.desc": "செயலிழந்த CNC, லேத்துகள், மோட்டார்கள், கியர்பாக்ஸ்கள், அழுத்தங்கள் — முழு தொழிற்சாலை அழிப்பு கிடைக்கும்.",
    "services.electrical.title": "மின் ஸ்க்ராப்",
    "services.electrical.desc": "செம்பு கம்பிகள், டிரான்ஸ்பார்மர்கள், பேனல்கள், கேபிள்கள், பஸ்பார்கள் மற்றும் மின் ஸ்க்ராப்.",
    "services.learnMore": "மேலும் பார்க்க",

    "why.overline": "/// ஏன் டயமண்ட்",
    "why.titleA": "தமிழ்நாட்டில்",
    "why.titleB": "தொழிற்சாலைகள்",
    "why.titleC": "நம்பும் நிறுவனம்.",
    "why.intro": "வேகமாக நகர்கிறோம், நியாயமாக எடைபோடுகிறோம், இடத்திலேயே செலுத்துகிறோம். மறைந்த கழிவுகள் இல்லை. மங்கலான மதிப்பீடுகள் இல்லை.",
    "why.b1": "வெளிப்படையான எடை",
    "why.b1d": "சரிபார்க்கப்பட்ட தராசுகள், இடத்திலேயே சரிபார்ப்பு.",
    "why.b2": "இலவச சேகரிப்பு",
    "why.b2d": "லாஜிஸ்டிக்ஸ், ஏற்றுதல் மற்றும் தொழிலாளர் சேர்க்கப்பட்டுள்ளது.",
    "why.b3": "உடனடி பணம்",
    "why.b3d": "ரொக்கம், RTGS அல்லது NEFT வெளியேறுவதற்கு முன்.",
    "why.b4": "பொறுப்பான மறுசுழற்சி",
    "why.b4d": "ஒவ்வொரு கிலோவும் சான்றளிக்கப்பட்ட செயலிகளுக்கு.",

    "home.gallery.overline": "/// சமீபத்திய தொகுதிகள்",
    "home.gallery.title": "எங்கள் களத்திலிருந்து.",
    "home.gallery.viewAll": "அனைத்தையும் காண்க",

    "cta.overline": "/// விற்க தயாரா?",
    "cta.titleA": "24 மணி நேரத்திற்குள்",
    "cta.titleB": "விலை பெறுங்கள்.",
    "cta.request": "மதிப்பீடு கேள்",

    "contact.overline": "/// தொடர்பு",
    "contact.titleA": "வாருங்கள்",
    "contact.titleB": "ஸ்க்ராப் பேசுவோம்.",
    "contact.intro": "உங்கள் பொருட்களைப் பற்றி எங்களுக்குச் சொல்லுங்கள். 24 மணி நேரத்தில் மதிப்பீட்டுடன் பதிலளிப்போம்.",
    "contact.form.title": "மதிப்பீடு பெறுக",
    "contact.form.formOverline": "/// மதிப்பீட்டு கோரிக்கை",
    "contact.form.name": "பெயர் *",
    "contact.form.phone": "தொலைபேசி *",
    "contact.form.email": "மின்னஞ்சல்",
    "contact.form.material": "பொருள் வகை",
    "contact.form.materialPh": "எ.கா. செம்பு கம்பி, CNC இயந்திரம்",
    "contact.form.message": "விவரம் *",
    "contact.form.messagePh": "தோராய அளவு, இடம், புகைப்படங்கள் உள்ளனவா, முதலியன.",
    "contact.form.submit": "அனுப்பவும்",
    "contact.form.sending": "அனுப்புகிறது…",
    "contact.form.success": "நன்றி — 24 மணி நேரத்திற்குள் தொடர்பு கொள்வோம்.",
    "contact.form.whatsapp": "WhatsApp வழியாக அனுப்பு",
    "contact.info.phone": "தொலைபேசி",
    "contact.info.email": "மின்னஞ்சல்",
    "contact.info.address": "முகவரி",
    "contact.bulk.overline": "/// மொத்த சேகரிப்பு",
    "contact.bulk.text": "500 கிலோவுக்கு மேல் இலவச போக்குவரத்து.",

    "about.overline": "/// டயமண்ட் ட்ரேடர்ஸ் பற்றி",
    "about.titleA": "எடை, நம்பிக்கை &",
    "about.titleB": "உலோகத்தில் கட்டப்பட்டது.",
    "about.mission": "/// நோக்கம்",
    "about.missionText": "தொழில் கழிவுகளை பொறுப்பான மதிப்பாக மாற்றுகிறோம் — ஒவ்வொரு தராசிலும்.",
    "about.hq": "/// தலைமையகம்",
    "about.hours": "/// நேரம்",
    "about.hoursText": "திங்கள் – சனி · காலை 9:00 – மாலை 7:00\nஞாயிறு · முன்பதிவு மூலம்",
    "about.point1": "உரிமம் பெற்ற ஸ்க்ராப் வியாபாரி",
    "about.point2": "மொத்த சேகரிப்பு திறன்",
    "about.point3": "இடத்திலேயே எடைபோடல்",
    "about.point4": "பயிற்சி பெற்ற குழு",
    "about.point5": "ஆவணப்படுத்தப்பட்ட அகற்றல்",
    "about.point6": "தமிழ்நாடு முழுவதும்",

    "servicesPage.overline": "/// சேவைகள்",
    "servicesPage.titleA": "நாங்கள்",
    "servicesPage.titleB": "வாங்குவது.",
    "servicesPage.intro": "இரும்பு, அலுமினியம், செம்பு, பித்தளை, மின் மற்றும் இயந்திர ஸ்க்ராப் — அனைத்து வகையும் ஏற்கப்படும்.",
    "servicesPage.getQuote": "மதிப்பீடு கேள்",

    "galleryPage.overline": "/// கேலரி",
    "galleryPage.titleA": "எங்கள்",
    "galleryPage.titleB": "களம்.",
    "galleryPage.intro": "சமீபத்திய சேகரிப்புகள் — இயந்திரங்கள், ஸ்க்ராப் தொகுதிகள், மின் அமைப்புகள்.",
    "galleryPage.empty": "சமீபத்திய திட்டங்களின் புகைப்படங்கள் இங்கே தோன்றும்.",
    "galleryPage.comingSoon": "/// விரைவில்",

    "footer.tagline": "சென்னையின் நம்பகமான ஸ்க்ராப் & இயந்திர சேகரிப்பு பங்காளர்.",
    "footer.operating": "/// தமிழ்நாடு முழுவதும் செயல்படுகிறது",
    "footer.sitemap": "/// தளவரைபடம்",
    "footer.reach": "/// எங்களை அணுகவும்",
    "footer.admin": "நிர்வாகி",
    "footer.copyright": "அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டுள்ளன",

    "wa.float": "WhatsApp இல் பேசவும்",
    "wa.quoteMsg": "வணக்கம் டயமண்ட் ட்ரேடர்ஸ், எனக்கு மதிப்பீடு வேண்டும்.",
    "common.directions": "வழிகாட்டு",
  },
};
